/* Tooltip "portal" : rendu en position fixed dans <body> pour ne jamais être
 * rogné par un ancêtre avec overflow:hidden/auto (ex : panneaux à défilement). */
let tooltipEl: HTMLDivElement | null = null;

function ensureTooltipEl(): HTMLDivElement {
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'ada-tooltip-portal';
    document.body.appendChild(tooltipEl);
  }
  return tooltipEl;
}

export function showTooltip(target: HTMLElement, text: string): void {
  const el = ensureTooltipEl();
  el.textContent = text;
  el.style.display = 'block';

  const rect = target.getBoundingClientRect();
  const tooltipRect = el.getBoundingClientRect();

  let left = rect.left + rect.width / 2 - tooltipRect.width / 2;
  left = Math.max(8, Math.min(left, window.innerWidth - tooltipRect.width - 8));

  let top = rect.top - tooltipRect.height - 8;
  const below = top < 4;
  if (below) top = rect.bottom + 8;

  el.style.left = `${left}px`;
  el.style.top = `${top}px`;
  el.style.setProperty('--ada-tooltip-arrow-x', `${rect.left + rect.width / 2 - left}px`);
  el.classList.toggle('ada-tooltip-portal--below', below);
}

export function hideTooltip(): void {
  if (tooltipEl) tooltipEl.style.display = 'none';
}

// Un scroll (y compris dans un conteneur interne, capturé grâce à la phase de capture)
// invalide la position calculée : on masque simplement le tooltip.
window.addEventListener('scroll', hideTooltip, true);
